import Vue from 'vue';
import Vuex from 'vuex';

import * as types from '@/store/mutation-types';

import projectService from '@/services/projects.js';
import userService from '@/services/users.js';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: undefined,
    userInfo: undefined,
    project: undefined,
    projectId: undefined,
    showLogicalLangage: false,
    debugMode: false,
    menuDrawer: false,
    helpDrawer: false,
    helpPage: undefined,
    mode: undefined,
  },
  mutations: {
    [types.LOAD_COGNITO_USER] (state, user) {
      state.user = user;
    },
    [types.LOGOUT_COGNITO_USER] (state) {
      state.user = undefined;
    },
    [types.LOAD_USER_INFO] (state, userInfo) {
      state.userInfo = userInfo;
    },
    [types.UNLOAD_USER_INFO] (state) {
      state.userInfo = undefined;
    },
    [types.LOAD_PROJECT] (state, project) {
      state.project = project;
    },
    [types.UNLOAD_PROJECT] (state) {
      state.project = undefined;
    },
    [types.SET_PROJECT_ID] (state, projectId) {
      state.projectId = projectId;
    },
    [types.UNSET_PROJECT_ID] (state) {
      state.projectId = undefined;
    },
    [types.UPDATE_SHOW_LOGICAL_LANGAGE] (state, value) {
      state.showLogicalLangage = value;
    },
    [types.DEBUG_MODE] (state) {
      state.debugMode = !state.debugMode;
    },
    [types.MENU_DRAWER] (state) {
      state.menuDrawer = !state.menuDrawer;
    },
    [types.HELP_DRAWER] (state) {
      state.helpDrawer = !state.helpDrawer;
    },
    [types.HELP_PAGE] (state, value) {
      state.helpPage = value;
    },
    [types.MODE] (state, value) {
      state.mode = value;
    },
  },
  actions: {
    setMode({ commit }, mode) {
      commit(types.MODE, mode);
    },
    setHelpPage({ commit }, helpPage) {
      commit(types.HELP_PAGE, helpPage);
    },
    loadCognitoUser({ commit }, user) {
      commit(types.LOAD_COGNITO_USER, user);
    },
    logoutCognitoUser({ commit }) {
      commit(types.LOGOUT_COGNITO_USER);
    },
    loadProject({ commit }, projectId) {
      return new Promise((resolve, reject) => {
        projectService.getProject(projectId).then(res => {
          commit(types.LOAD_PROJECT, res.data);
          resolve(res.data);
        }).catch(err => {
          reject(err);
        });
      });
    },
    unloadProject({ commit }) {
      commit(types.UNLOAD_PROJECT);
    },
    setProjectId({ commit }, projectId) {
      commit(types.SET_PROJECT_ID, projectId);
    },
    unsetProjectId({ commit }) {
      commit(types.UNSET_PROJECT_ID);
    },
    loadUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        userService.getUserInfo()
          .then(response => {
            commit(types.LOAD_USER_INFO, response.data);
            commit(types.MODE, response.data.settings.mode);
            resolve(response.data);
          }).catch(err => {
            reject(err);
          });
      });
    },
    unloadUserInfo({ commit }) {
      commit(types.UNLOAD_USER_INFO);
    }
  },
  modules: {
  },
});
